// src/utils/storage.utils.ts

import { ItemCategory } from '../types/storage.types';

export const formatBytes = (bytes: number): string => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

export const withTimeout = async <T>(
  promise: Promise<T>,
  timeoutMs: number = 10000,
  operation: string = "operación"
): Promise<T> => {
  const timeoutPromise = new Promise<never>((_, reject) => {
    setTimeout(() => {
      reject(new Error(`Timeout: ${operation} tomó más de ${timeoutMs}ms`));
    }, timeoutMs);
  });

  try {
    return await Promise.race([promise, timeoutPromise]);
  } catch (error) {
    console.error(`❌ Error en ${operation}:`, error);
    throw error;
  }
};

export const getHealthColor = (status: string) => {
  switch (status) {
    case "healthy":
      return "green";
    case "warning":
      return "orange";
    case "error":
      return "red";
    default:
      return "default";
  }
};

export const getCategoryColor = (category: ItemCategory) => {
  const colorMap = {
    photo: "green",
    workflow: "orange",
    sync: "purple",
    other: "default",
  };
  return colorMap[category];
};

export const getCategoryLabel = (category: ItemCategory) => {
  const labelMap = {
    photo: "Foto",
    workflow: "Workflow",
    sync: "Sync",
    other: "Otro",
  };
  return labelMap[category];
};

export const getCategoryIcon = (category: ItemCategory) => {
  // Estas funciones retornan strings que luego se mapean a iconos en el componente
  const iconMap = {
    photo: "PictureOutlined",
    workflow: "FileTextOutlined",
    sync: "SyncOutlined",
    other: "DatabaseOutlined",
  };
  return iconMap[category];
};

export const createServiceWorkerPromise = <T>(
  swController: ServiceWorker,
  messageType: string,
  data?: any,
  timeoutMs: number = 5000
): Promise<T> => {
  return withTimeout(
    new Promise<T>((resolve, reject) => {
      const channel = new MessageChannel() as any;
      channel.port1.onmessage = (event:any) => {
        if (event.data.type === messageType) {
          resolve(event.data);
        }
      };
      channel.port1.onerror = reject;
      
      swController.postMessage({ type: messageType, ...data }, [channel.port2]);
    }),
    timeoutMs,
    `service worker ${messageType}`
  );
};